<template>
  <HeaderContent title="Source" />
  <ActionContent
    ctaText="Add Source"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <SourceStatistics title="Source Statistics" :data="statistics" />
  <SourceForm
    :modal="modal"
    :sourceData="source"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <SourceConfirm
    title="Confirmation"
    :uuid="sourceUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(sourceUuid)"
  >
    <template #text>Are you sure to delete this data ?</template>
  </SourceConfirm>
  <SourceDataTable
    :data="sources"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import SourceForm from "./SourceForm.vue";
import SourceDataTable from "@/components/DataTable.vue";
import SourceStatistics from "@/components/StatisticData.vue";
import SourceConfirm from "@/components/ModalDialog.vue";
import iconSource from "../../../public/icons/source-document-alt.svg";
import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    SourceForm,
    SourceDataTable,
    SourceStatistics,
    SourceConfirm,
  },
  setup() {
    const repositories = inject("repositories");
    const sourceRepository = repositories ? repositories.source : null;
    const modal = ref(false);
    const modalConfirm = ref(false);
    const sourceUuid = ref(null);
    const source = ref({});
    const sources = ref([]);

    const headers = ref([
      {
        key: "no",
        label: "No",
        class: "text-left",
      },
      {
        key: "type",
        label: "Type",
        sortable: true,
        class: "text-left",
      },
      {
        key: "name",
        label: "Name",
        sortable: true,
        class: "text-left",
      },
      {
        key: "description",
        label: "Description",
        sortable: true,
        class: "text-left",
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const statistics = ref([]);

    const getAll = async () => {
      await sourceRepository
        .getAll()
        .then((res) => {
          sources.value = res.data.data.map((item) => {
            return {
              ...item,
              type: item.type
                .split("_")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" "),
            };
          });

          statistics.value = [
            {
              label: "Total",
              key: "Source",
              value: res.data.data.length,
              color: "primary",
              icon: iconSource,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getById = async (uuid) => {
      await sourceRepository
        .getById(uuid)
        .then((res) => {
          source.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      source.value = {};
    };

    const showModal = () => {
      modal.value = true;
      source.value = { type: null };
    };

    const showConfirmModal = (uuid) => {
      modalConfirm.value = true;
      sourceUuid.value = uuid;
    };

    const deleteData = async (uuid) => {
      await sourceRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await sourceRepository
        .search(keyword)
        .then((res) => {
          sources.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      sourceUuid,
      source,
      sources,
      headers,
      customActions,
      statistics,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      searchData,
    };
  },
};
</script>
